var _defs, _path, _path2, _path3, _path4, _path5, _line, _line2, _path6, _line3, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoodSwingsSliderIcon4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 113.39 113.39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1-mood-swings,.cls-2-mood-swings{fill:none;stroke:#fff;stroke-width:3px;}.cls-1-mood-swings{stroke-miterlimit:10;}.cls-2-mood-swings{stroke-linecap:round;stroke-linejoin:round;}.cls-3-mood-swings{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1-mood-swings",
    d: "M20.25,104s-.93-12,0-18,4.85-11.79,9.94-13.41,13-3.93,19.42-3.24l6.48.7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1-mood-swings",
    d: "M93.14,104s.92-12,0-18S88.28,74.17,83.2,72.55s-13-3.93-19.43-3.24L57.3,70"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1-mood-swings",
    d: "M60.31,32.35a15.14,15.14,0,0,1-20.18,9.73,31.78,31.78,0,0,0-.23,3.69c0,13.44,8,24.33,17.76,24.33S75.42,59.21,75.42,45.77a32.78,32.78,0,0,0-.74-7,14.56,14.56,0,0,1-1.87.13A15.16,15.16,0,0,1,60.31,32.35Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1-mood-swings",
    d: "M49.61,69.31c-1.24-4.75-22.49-6.21-22.49-11.59,0-23.95,13.51-43.36,30.18-43.36S87.47,33.77,87.47,57.72c0,5.59-19.87,6.56-21.21,11.47"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1-mood-swings",
    d: "M66.08,71.25c0,5.3-3.93,9.59-8.78,9.59s-8.79-4.29-8.79-9.59"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-2-mood-swings",
    x1: 35.74,
    y1: 88.04,
    x2: 35.74,
    y2: 104
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2-mood-swings",
    x1: 77.67,
    y1: 88.04,
    x2: 77.67,
    y2: 104
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3-mood-swings",
    d: "M16.33,38.55l-.42-.78a7.78,7.78,0,0,1-.45-6.18c.66-2.25.89-3.79.28-5.18-.7-1.57-2.15-2.18-4.11-1.35A6,6,0,0,0,8.94,27.4l-1.6-1.61a9,9,0,0,1,3.86-3.2c3.55-1.57,6.12-.1,7.16,2.25.93,2.09.43,4.12-.27,6.54a6.75,6.75,0,0,0,.27,5.34l.41.75Zm1.29,4.63a2,2,0,0,1,.95-2.75,2.11,2.11,0,1,1-.95,2.75Z"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2-mood-swings",
    x1: 50.54,
    y1: 56.67,
    x2: 66.08,
    y2: 56.67
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1-mood-swings",
    d: "M37.46,13.57a3.4,3.4,0,0,0-3.84-2.89A3.48,3.48,0,0,0,30.72,13a3.46,3.46,0,0,0-3.36-1.57,3.4,3.4,0,0,0-3,3.72,3.1,3.1,0,0,0,.32,1.07,3.39,3.39,0,0,0,.77,1,4.8,4.8,0,0,0,.43.32l5.84,4.38a.28.28,0,0,0,.13,0,.24.24,0,0,0,.11-.06L36.73,16h0a3.31,3.31,0,0,0,.66-1.31A3.17,3.17,0,0,0,37.46,13.57Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3-mood-swings",
    d: "M91.62,34.46a2,2,0,0,1,2.07-2.14,2,2,0,0,1,2,2.14,2,2,0,1,1-4.07,0Zm.86-4.9L92,12.94h3.31l-.48,16.62Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoodSwingsSliderIcon4);
export default __webpack_public_path__ + "static/media/mood_swings_slider_icon_4.bb60f447.svg";
export { ForwardRef as ReactComponent };